<template>
	<div id="finance-applying">
		<div class="base">
			<van-field v-model="name" input-align="right" label="申请人" placeholder="请输入名称" maxlength="15" />
			<van-field
				v-model="phone"
				type="tel"
				input-align="right"
				label="联系电话"
				placeholder="请输入联系电话"
				:error-message="phoneErrorMessage"
				@blur="isValidPhone"
				maxlength="11"
				error-message-align="right"
			/>
			<van-field v-model="company" input-align="right" label="公司名称" placeholder="请输入公司名称" maxlength="50" />
		</div>

		<div class="introduce">
			<div class="title">公司简介</div>
			<van-field v-model="introduce" autosize type="textarea" placeholder="请输入简介(500字内)" show-word-limit maxlength="500" />
		</div>

		<div class="prospectus">
			<van-cell is-link @click="change">
				<template slot="title">
					<span class="custom-title">
						<span class="label">融资轮次</span>
						<span class="wheel">{{ round }}</span>
					</span>
				</template>
			</van-cell>

			<van-field v-model="money" type="number" input-align="right" label="金额" placeholder="请输入金额" maxlength="8" />

			<div class="book">
				<div class="title">商业计划书</div>
				<div class="file-image">
					<van-uploader v-model="imgFile" :after-read="uploadImg" :max-count="3" preview-size="3.75rem" multiple accept="image/*" />
				</div>
			</div>
		</div>

		<div id="btn-container">
			<van-button
				id="btn-apply"
				type="info"
				:disabled="token == '' || name.trim() == '' || round == '' || imgFile.length < 1 || !isValidPhoneFlag || company.trim() == '' || money <= 0 || isUploading"
				@click="submit"
				block
				>提交</van-button
			>
		</div>

		<van-popup v-model="showPicker" position="bottom">
			<van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
		</van-popup>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			name: '',
			phone: '',
			company: '',
			introduce: '',
			round: '',
			money: 0,
			imgFile: [],
			showPicker: false,
			columns: ['天使轮', 'A轮', 'B轮', 'C轮'],
			uploadImageUrls: [],
			phoneErrorMessage: '',
			isValidPhoneFlag: false,
			isUploading: false,
		}
	},
	computed: {
		...mapGetters(['token', 'userId', 'communityId']),
	},
	watch: {
		communityId() {
			this.submit()
		},
	},
	methods: {
		//手机号码校验
		isValidPhone() {
			var numReg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/
			if (!numReg.test(this.phone)) {
				this.phoneErrorMessage = '非法手机号'
				this.isValidPhoneFlag = false
			} else {
				this.phoneErrorMessage = ''
				this.isValidPhoneFlag = true
			}
		},
		//提交申请
		submit() {
			let attachs = []
			if (this.uploadImageUrls.length > 0) {
				for (let item of this.uploadImageUrls) {
					let list = {}
					list.attach_type = 2
					list.attach_name = item.filename
					list.attach_url = item.url
					attachs.push(list)
				}
			}
			this.isUploading = true
			this.vaxios.post(
				`${this.vaxios.host}/api/v1/investment-finance-applies`,
				{
					community_id: this.communityId,
					applicant_name: this.name,
					phone: this.phone,
					company_name: this.company,
					introduction: this.introduce,
					round: this.round,
					amount: this.money,
					apply_by: this.userId,
				},
				(res) => {
					if (res.msg != '') {
						this.$toast.success('提交成功')
						setTimeout(() => {
							this.$router.go(-1)
						}, 600)
					}
					this.isUploading = false
				},
				(err) => {
					console.log(err)
					this.isUploading = false
				},
				{
					headers: {
						Authorization: 'Bearer ' + this.token,
						'Content-Type': 'application/json',
					},
				}
			)
		},

		//提交文件
		uploadImg(file) {
			var formData = new FormData()
			formData.append('file', file.file)
			this.isUploading = true
			this.vaxios.post(
				`${this.vaxios.host}/api/v1/storages/upload`,
				formData,
				(res) => {
					this.uploadImageUrls.push(res.data)
					this.$toast('上传成功')
					this.isUploading = false
				},
				(e) => {
					console.log('上传失败', e)
					this.isUploading = false
				},
				{
					headers: {
						Authorization: 'Bearer ' + this.token,
						'Content-Type': 'multipart/form-data',
					},
				}
			)
		},

		change() {
			this.showPicker = true
		},
		onConfirm(value) {
			this.round = value
			this.showPicker = false
		},
	},
	mounted() {
		if (this.token == '' || !this.token) {
			this.$toast('账号未登录')
		}
	},
}
</script>

<style>
#finance-applying {
	height: 100%;
	background-color: #f5f5f5;
	padding-top: 0.75rem;
	padding-bottom: 1rem;
	font-size: 1rem;
	color: #272727;
}

.title {
	padding-top: 1rem;
	padding-left: 1.09375rem;
}

.prospectus,
.introduce {
	background-color: #ffffff;
	margin-top: 0.75rem;
}

.book {
	margin-top: 0.75rem;
}

.file-image {
	margin-top: 0.875rem;
	margin-left: 1rem;
}

#btn-container {
	bottom: 4.78%;
	margin-top: 3.3125rem;
	width: 100%;
	text-align: center;
}

#btn-apply {
	width: 91.47%;
	font-size: 1.125rem;
	height: 2.75rem;
	padding: 0;
	margin: 0 auto;
}

.custom-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
</style>
